// The hero orders of the local house, read once per snapshot.
import type { GameSnapshot } from '@aod/protocol';
import { useMemo } from 'react';
import { type HeroQuests, readHeroQuests } from './quests.js';

export function useHeroQuestsView(
  snapshot: GameSnapshot | null,
  playerIndex: number,
): HeroQuests | null {
  return useMemo(() => readHeroQuests(snapshot, playerIndex), [snapshot, playerIndex]);
}
